module.exports = __webpack_public_path__ + "media/images/lp/1/plight4-sp-281f5601a7805331d3f8eb9e80bc9e91.png";